import React from "react";

/**
 * Skeleton placeholder matching PlMetricCard layout (label, value, footer).
 */
export function PlMetricCardSkeleton() {
  return (
    <div className="flex grow shrink-0 basis-0 flex-col items-start overflow-hidden rounded-xl border border-solid border-neutral-200">
      <div className="flex w-full flex-col items-start gap-4 bg-white px-5 py-5">
        <div className="flex w-full items-start justify-between">
          <div
            className="animate-pulse rounded bg-neutral-200"
            style={{ height: 14, width: 80 }}
            aria-hidden
          />
          <div className="flex h-8 w-8 flex-none flex-col items-center justify-center rounded-full bg-neutral-100">
            <div
              className="animate-pulse rounded bg-neutral-200"
              style={{ height: 16, width: 16 }}
              aria-hidden
            />
          </div>
        </div>
        <div
          className="animate-pulse rounded bg-neutral-200"
          style={{ height: 32, width: 120 }}
          aria-hidden
        />
      </div>
      <div className="flex w-full items-center gap-1 border-t border-solid border-neutral-100 bg-neutral-50 px-5 py-3">
        <div
          className="animate-pulse rounded bg-neutral-200"
          style={{ height: 12, width: 72 }}
          aria-hidden
        />
        <div
          className="animate-pulse rounded bg-neutral-200"
          style={{ height: 12, width: 56 }}
          aria-hidden
        />
      </div>
    </div>
  );
}
